import { Link } from "react-router-dom";
import GoogleAuthButton from "./GoogleAuthButton";
import FormBuilder from "../../common/components/formInputs/FormBuilder";
import OtherSigninOptions from "./OtherSigninOptions";

function getFormInputs() {
  return [
    {
      type: "text",
      name: "userName",
      label: "Full name",
      placeholder: "Full name",
      validation: {
        required: "Full name is required",
      },
    },
    {
      type: "text",
      name: "email",
      label: "Email",
      placeholder: "name@example.com",
      validation: {
        required: "Email is required",
        pattern: {
          value: /^\S+@\S+$/,
          message: "Invalid email address",
        },
      },
    },
  ];
}

function SignupForm({ onSubmit, isSubmitting }) {
  return (
    <div className="text-gray-700 md:10/12 lg:w-7/12">
      <div className="font-bold text-center my-2 mb-4 text-2xl font-bold">
        SIGN UP
      </div>

      <div className="flex justify-center items-center space-x-2 text-gray-500 pb-2">
        <div>Already have an account?</div>

        <div className="text-center">
          <Link to="/login" className="back_link underline">
            Login
          </Link>
        </div>
      </div>

      <FormBuilder
        formInputs={getFormInputs()}
        submitButtonLabel="Sign up"
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
      />

      <OtherSigninOptions />
    </div>
  );
}

export default SignupForm;
